import React from 'react';
import PageHero from '../components/site/PageHero';
import { stats } from '../mock';
import { CtaBanner } from '../components/site/BottomSections';
import Memorial from '../components/site/Memorial';
import { Quote } from 'lucide-react';

const leaders = [
  {
    name: 'Mr. Rajesh Rawat',
    role: 'Director & Co-Founder',
    image: 'https://ewenrealtors.com/assets/images/chairman-er.png',
    quote: 'Don\u2019t wait to buy real estate. Buy real estate and wait.',
    body: [
      'Ewen Realtors is a company with a purpose \u2014 to help every family find a place they can truly call home. We are not building properties. We are creating destinations across Uttarakhand where a lifestyle, and not just a house, comes together.',
      'For over a decade, we have grown by placing our clients\u2019 needs above everything else. Their success has always been our success \u2014 and our commitment to serving them better is what defines the road ahead.',
      'I invite you to spend some time on our website, understand our projects and our philosophy, and reach out whenever you are ready. We would love to walk this journey with you.',
    ],
  },
  {
    name: 'Mr. Surya Pratap Singh',
    role: 'Director, Co-Founder & CEO',
    image: 'https://ewenrealtors.com/assets/images/Surya-Pratap-Singh-CEO.jpeg',
    quote: 'Real estate is an imperishable asset, ever\u2011increasing in value.',
    body: [
      'The hills of Uttarakhand offer some of the most compelling second\u2011home opportunities in India today \u2014 across price points, and with the very real prospect of steady rental income for owners.',
      'Since the pandemic, we have watched a quiet shift: families and professionals are choosing the mountains not just as an escape, but as an address. Uttarakhand has emerged as one of the country\u2019s preferred second\u2011home destinations, and demand continues to grow year on year.',
      'Our promise is to bring you thoughtfully designed, well\u2011located and legally clean opportunities \u2014 so your investment protects itself, and your family enjoys it for generations.',
    ],
  },
];

function LeaderBlock({ leader, reverse }) {
  return (
    <article className={`grid md:grid-cols-12 gap-10 lg:gap-14 items-center ${reverse ? 'md:[&>*:first-child]:order-2' : ''}`}>
      <div className="md:col-span-5">
        <div className="relative">
          <div className="relative aspect-[4/5] overflow-hidden bg-[#0f1a14]">
            <img src={leader.image} alt={leader.name} className="h-full w-full object-cover" />
          </div>
          <div className="absolute -bottom-4 -right-4 hidden md:block bg-[#c9a56a] text-[#0f1a14] px-5 py-3 shadow-md">
            <div className="text-[10px] uppercase tracking-[0.25em]">Leadership</div>
            <div className="font-serif text-lg">{leader.role.split('&')[0].trim()}</div>
          </div>
        </div>
      </div>
      <div className="md:col-span-7">
        <div className="flex items-center gap-3 mb-4">
          <div className="h-px w-12 bg-[#8a6b3a]" />
          <span className="text-[#8a6b3a] text-xs uppercase tracking-[0.3em]">A Word From</span>
        </div>
        <h3 className="font-serif text-3xl md:text-4xl text-[#0f1a14] leading-tight">
          {leader.name}
        </h3>
        <div className="text-[#8a6b3a] text-sm tracking-wide mt-1">{leader.role}</div>
        <div className="relative mt-8 pl-8 border-l-2 border-[#c9a56a]">
          <Quote className="h-8 w-8 text-[#c9a56a] absolute -left-4 -top-3 bg-[#f6f1e7]" />
          <p className="font-serif text-2xl text-[#0f1a14] leading-snug italic">
            &ldquo;{leader.quote}&rdquo;
          </p>
        </div>
        <div className="mt-8 space-y-4 text-[#0f1a14]/75 leading-relaxed text-lg">
          {leader.body.map((p, i) => <p key={i}>{p}</p>)}
        </div>
      </div>
    </article>
  );
}

export default function About() {
  return (
    <div>
      <PageHero
        eyebrow="About Ewen Realtors"
        title="A story that began in the mountains."
        subtitle="Since 2011, we have been shaping homes and legacies across Uttarakhand."
        image="/gallery_2025/Firefly 20250419114040.png"
      />

      {/* Intro */}
      <section className="bg-[#f6f1e7] py-24">
        <div className="mx-auto max-w-5xl px-6 lg:px-10">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-px w-12 bg-[#8a6b3a]" />
            <span className="text-[#8a6b3a] text-xs uppercase tracking-[0.3em]">Our Story</span>
          </div>
          <h2 className="font-serif text-3xl md:text-5xl text-[#0f1a14] leading-[1.15]">
            We are not building properties. We are building <em className="text-[#8a6b3a] not-italic">dreams, stories and legacies</em> that last a lifetime.
          </h2>
          <div className="mt-10 text-[#0f1a14]/75 leading-relaxed space-y-5 text-lg">
            <p>
            Ewen Realtors is a new startup with an aim of “Defining Dreams” with 11 years of experience in real estate with the JMB group. The company is firmly established as one of the best emerging real estate companies in Uttarakhand with a decade of experience.
<br/><br/>
The reason for being and emerging as the best is that we understand our clients in every aspect by providing a wide array of real estate services. Also, we will walk you through every stage of the process, from buying to building to paperwork to home financing and much more.
Ewen Realtors intend to take your real estate experience to new heights and keep your priorities on top. Since Covid-19 demand for townships in the mountains has increased and is gaining a lot of attention all over India.
So, After successfully covering the mountains market the some of the finest development in Uttarakhand, Ewen Realtors has now landed in the Queen’s Meadow Ranikhet.
<br/><br/>
In keeping with our commitment to providing a world-class township in Uttarakhand, we are pleased to introduce our ongoing project “The Ewen Park” with a majestic view of the Himalayas. Township is designed to offer you a wholesome living experience. Live a blissful life and embrace the beauty of nature.
<br/><br/>
Smart living and a convenient lifestyle that you wished for in your life. A well-connected township that has nature as its neighbour.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[#0f1a14]/10 border border-[#0f1a14]/10 mt-16">
            {stats.map((s) => (
              <div key={s.label} className="bg-[#f6f1e7] p-8">
                <div className="font-serif text-5xl text-[#0f1a14]">{s.value}</div>
                <div className="text-xs uppercase tracking-[0.25em] text-[#8a6b3a] mt-3">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Leadership */}
      <section className="bg-[#f6f1e7] pb-24">
        <div className="mx-auto max-w-6xl px-6 lg:px-10">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="h-px w-12 bg-[#8a6b3a]" />
              <span className="text-[#8a6b3a] text-xs uppercase tracking-[0.3em]">Leadership</span>
              <div className="h-px w-12 bg-[#8a6b3a]" />
            </div>
            <h2 className="font-serif text-4xl md:text-5xl text-[#0f1a14] leading-[1.1]">
              The people who make the promise.
            </h2>
            <p className="text-[#0f1a14]/70 max-w-2xl mx-auto mt-5">
              Every home we build begins with a conversation. Here are the two people who set the tone for every one of them.
            </p>
          </div>
          <div className="space-y-24">
            {leaders.map((l, i) => (
              <LeaderBlock key={l.name} leader={l} reverse={i % 2 === 1} />
            ))}
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="bg-white py-24">
        <div className="mx-auto max-w-6xl px-6 lg:px-10">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-px w-12 bg-[#8a6b3a]" />
            <span className="text-[#8a6b3a] text-xs uppercase tracking-[0.3em]">What We Stand For</span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl text-[#0f1a14] leading-[1.1] max-w-2xl">Four values, one decade, zero shortcuts.</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
            {[
              { n: '01', t: 'Honesty', d: 'Freehold, RERA\u2011registered land with a transparent title chain \u2014 every single time.' },
              { n: '02', t: 'Craft', d: 'Locally sourced Kumaoni stone and pine, shaped by artisans who have worked with us for years.' },
              { n: '03', t: 'Care', d: 'A single accountable team from the first site visit to the final key handover \u2014 and beyond.' },
              { n: '04', t: 'Community', d: 'Every township plants 200+ native trees per acre and hires within the local district.' },
            ].map((v) => (
              <div key={v.n} className="p-8 border border-[#0f1a14]/10 hover:border-[#8a6b3a] transition-colors bg-[#f6f1e7]/40">
                <div className="font-serif text-5xl text-[#c9a56a]">{v.n}</div>
                <h3 className="font-serif text-2xl text-[#0f1a14] mt-4">{v.t}</h3>
                <div className="h-px w-8 bg-[#8a6b3a] my-4" />
                <p className="text-[#0f1a14]/70 text-sm leading-relaxed">{v.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Kesar Singh memorial */}
      <Memorial />

      <CtaBanner />
    </div>
  );
}
